import {LocSlotPair} from "@components/Locations/usePairLocsWithSlots";
import {ApptSlot} from "@services/monolith/availability";
import React from "react";
import {LocationFragment} from "src/queries/useFetchSlotsInArea";

import {CarePractitionerFragment} from "../__generated__/care-practitioners-by-doctor-ids.type";
import NoSlots from "./components/NoSlots";
import ProviderSlotGroup, {Loading} from "./components/ProviderSlotGroup";

type Props = {
  slotsGroupedByProvider: (LocSlotPair<LocationFragment> & {doctor: CarePractitionerFragment})[];
  loading: boolean;
  selectedSlotTime?: number;
  getOnSlotSelection: (location: LocationFragment) => (apptSlot: ApptSlot) => unknown;
  disabled?: boolean;
};

/**
 * Renders a list of slots grouped by provider.
 */
const PrimaryCareSlots = ({
  slotsGroupedByProvider,
  loading,
  selectedSlotTime,
  getOnSlotSelection,
  disabled,
}: Props) => {
  if (loading) return <Loading />;
  if (slotsGroupedByProvider.length === 0) return <NoSlots />;
  return (
    <div className="flex flex-col gap-8 w-full [&>*:not(:last-child)]:border-solid [&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-x-0 [&>*:not(:last-child)]:border-t-0 [&>*:not(:last-child)]:border-b-gray-200 [&>*:not(:last-child)]:pb-4">
      {slotsGroupedByProvider.map(({doctor, location, slots}) => {
        if (location.address && doctor && doctor.firstName && doctor.lastName) {
          return (
            <ProviderSlotGroup
              key={doctor.id}
              firstName={doctor.firstName}
              lastName={doctor.lastName}
              credential={doctor.credential || ""}
              imageId={doctor.coverImage?.id || ""}
              address={{
                street: location.address.firstLine,
                city: location.address.city,
              }}
              timezone={location.timezone}
              selectedSlotTime={selectedSlotTime}
              slots={slots}
              onSlotSelection={getOnSlotSelection(location)}
              disabled={disabled}
            />
          );
        }
      })}
    </div>
  );
};

export default React.memo(PrimaryCareSlots);
